module.exports = __webpack_public_path__ + "resources/img/solution_game_en_m.38aae3e5c93c02875c91fbe1d59ead3b.jpg";